import { useEffect } from 'react';
import { useAppState, useAppDispatch } from '../../../AppContext';

const AppRedirect = () => {
  const state = useAppState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const redirectUrl = state?.redirect;

    if (redirectUrl && typeof redirectUrl === 'string' && redirectUrl.trim() !== '') {
      // Save feedback to localStorage if both feedbackMessage and feedbackVariant are defined and not null
      if (state?.feedbackMessage != null && state?.feedbackVariant != null) {
        localStorage.setItem("IsibuteFeedbackMessage", state.feedbackMessage);
        localStorage.setItem("IsibuteFeedbackVariant", state.feedbackVariant);
      }

      // Clear the redirect field from state before redirecting
      dispatch((appState) => ({
        ...appState,
        redirect: null,
      }));

      window.location.assign(redirectUrl);
    }
  }, [state?.redirect, state?.feedbackMessage, state?.feedbackVariant, dispatch]);

  return null;
};

export default AppRedirect;
